import React, { createContext, useContext, useState, useCallback } from 'react';

interface MapLinkContextValue {
  hoveredLinkId: string | null;
  setHoveredLinkId: (id: string | null) => void;
}

const MapLinkContext = createContext<MapLinkContextValue>({
  hoveredLinkId: null,
  setHoveredLinkId: () => {},
});

export const useMapLink = () => useContext(MapLinkContext);

export const MapLinkProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hoveredLinkId, setHoveredLinkIdRaw] = useState<string | null>(null);
  const setHoveredLinkId = useCallback((id: string | null) => {
    console.log('[MapLink] setHoveredLinkId:', id);
    setHoveredLinkIdRaw(id);
  }, []);

  return (
    <MapLinkContext.Provider value={{ hoveredLinkId, setHoveredLinkId }}>
      {children}
    </MapLinkContext.Provider>
  );
};
